import { render, staticRenderFns } from "./courseNormalDetail.vue?vue&type=template&id=87f48420&scoped=true"
import script from "./courseNormalDetail.vue?vue&type=script&lang=js"
export * from "./courseNormalDetail.vue?vue&type=script&lang=js"
import style0 from "./courseNormalDetail.vue?vue&type=style&index=0&id=87f48420&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87f48420",
  null
  
)

export default component.exports